import React, { Component } from "react"

import {
    enumGenericFilter,
    toggleGenericFilter,
    searchifySelectGenericFilter,
    createSelectToggleMultiFilter,
} from "shared/search/containers/Filter/FilterCreators"

import {
    CommitteeFilterableListView,
    LegislatorSearchifyWithoutCampaignFinanceFLV,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import {
    CommitteeSelect,
    LegislatorSelectWithoutCampaignFinance,
} from "app/static/frontend/selects/containers/PieSelect"
import { BillSupportedRegionSelect } from "app/static/frontend/selects/containers/EnumSelect"

import { getCommitteeSupportedRegionOptions } from "shared/selects/helperFunctions"
import { usRegions } from "shared/imports/regionConstants"

export class CommitteeTypeFilter extends Component {
    static get defaultProps() {
        const committeeGroup = DjangIO.app.committee.models.CommitteeType.filter_groups.find(
            (type) => type.title === DjangIO.app.models.QuorumDataType.committee.label,
        )

        return {
            filterComponent: enumGenericFilter,
            uniqueFilterId: "committeeTypeFilter",
            filterKey: "committee_type__in",
            enumItems: DjangIO.app.committee.models.CommitteeType.region_supported_items().filter((item) =>
                committeeGroup.values.includes(item.value),
            ),
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class CommitteeIsParentFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "committeeIsParent",
        filterKey: "is_parent_committee",
        trueText: "Hide Subcommittees",
        falseText: "Only Subcommittees",
        displayLabel: "Subcommittees",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const CommitteeOfficialFilter = createSelectToggleMultiFilter({
    uniqueFilterId: "committeeMemberFilter",
    getSearchifyFLV: () => LegislatorSearchifyWithoutCampaignFinanceFLV,
    dataTypeLabel: "Members",
    filterKeyMapping: { true: "has_members_or", false: "has_members_and" },
    selectComponent: LegislatorSelectWithoutCampaignFinance,
})

export class CommitteeSubcommitteeFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "subcommittees",
            searchifyFLV: CommitteeFilterableListView,
            dataTypeLabel: "Parent Committee",
            filterKey: "subcommittee",
            selectComponent: CommitteeSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const CommitteeSupportedRegionsFilter = (props) => {
    const FilterComponent = props.filterComponent

    return <FilterComponent {...props} />
}
CommitteeSupportedRegionsFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    enumItems: getCommitteeSupportedRegionOptions(),
    uniqueFilterId: "committeeSupportedRegionsFilter",
    filterKey: "for_supported_regions",
    // Not actually Bill Specific
    selectComponent: BillSupportedRegionSelect,
    regions: usRegions,
    displayKey: "region_name",
}
